var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-64 w-full mx-auto",staticStyle:{"position":"relative"}},[(_vm.datacollection)?_c('chart',{ref:"bar",staticClass:"max-w-full h-full",attrs:{"chart-data":_vm.datacollection,"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }